import { Chip, Tooltip } from '@mui/material';
import { DateTime } from 'luxon';
import { type FC } from 'react';

import type { MediaStatusStream } from '@okvc/schema';

const STATE_CHIP: Record<MediaStatusStream['state'], { label: string; color: 'default' | 'warning' | 'success' | 'error' }> = {
  online: { label: 'Online', color: 'success' },
  pending: { label: 'Connecting…', color: 'warning' },
  missing: { label: 'Missing', color: 'error' },
  error: { label: 'Start failed', color: 'error' },
  unknown: { label: 'Unknown', color: 'default' },
};

function buildTooltip(stream: MediaStatusStream): string {
  if (stream.state === 'online') {
    return stream.viewers > 0 ? `Playing to ${stream.viewers} viewer${stream.viewers === 1 ? '' : 's'}` : 'Online, no viewers';
  }
  if (stream.state === 'pending' && stream.pendingSince) {
    return `Connecting since ${DateTime.fromISO(stream.pendingSince).toRelative()}`;
  }
  if (stream.state === 'unknown') {
    return 'Owning media server is unreachable';
  }
  if (stream.lastError) {
    return `${stream.lastError.message} (${DateTime.fromISO(stream.lastError.at).toRelative()})`;
  }
  return STATE_CHIP[stream.state].label;
}

const StreamStateChip: FC<{ stream: MediaStatusStream }> = ({ stream }) => {
  const { label, color } = STATE_CHIP[stream.state];
  return (
    <Tooltip arrow title={buildTooltip(stream)}>
      <Chip size="small" label={label} color={color} variant={stream.state === 'unknown' ? 'outlined' : 'filled'} />
    </Tooltip>
  );
};

export default StreamStateChip;
